import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import { apiDeleteFetcher, apiPutFetcher } from '@/common/api/fetcher'
import {
  CreateReviewFieldVars,
  CreateScheduleRuleVars,
  DeleteScheduleRuleVars,
  RuleBrandsResponse,
  RuleCategoriesResponse,
  RulePriceRangesResponse,
  CreateTemplateVars,
  DeleteReviewFieldVars,
  DeleteTemplateVars,
  ListReviewFieldsResponse,
  ListReviewFieldsVars,
  ListScheduleRulesResponse,
  ListScheduleRulesVars,
  ListTemplatesResponse,
  ListTemplatesVars,
  UGCReviewSetupApiPath,
  UpdateScheduleRuleVars,
  UpdateTemplateVars
} from '@/common/api/params/ugcReviewSetup'

export const useReviewTemplatesApi = (vars: ListTemplatesVars | undefined) => {
  return useSWR<ListTemplatesResponse, Response, [string, ListTemplatesVars] | undefined>(
    vars ? [UGCReviewSetupApiPath.LIST_TEMPLATES, vars] : undefined
  )
}

export const useCreateReviewTemplateApi = (options?: MutationOptions<{ id: number }>) => {
  return useCallMutation<{ id: number }, CreateTemplateVars>(
    UGCReviewSetupApiPath.CREATE_TEMPLATE,
    options
  )
}

export const useUpdateReviewTemplateApi = (options?: MutationOptions<{ ok: boolean }>) => {
  return useCallMutation<{ ok: boolean }, UpdateTemplateVars>(
    UGCReviewSetupApiPath.UPDATE_TEMPLATE,
    options,
    apiPutFetcher
  )
}

export const useDeleteReviewTemplateApi = (options?: MutationOptions<{ ok: boolean }>) => {
  return useCallMutation<{ ok: boolean }, DeleteTemplateVars>(
    UGCReviewSetupApiPath.DELETE_TEMPLATE,
    options,
    apiDeleteFetcher
  )
}

export const useScheduleRulesApi = (vars: ListScheduleRulesVars | undefined) => {
  return useSWR<ListScheduleRulesResponse, Response, [string, ListScheduleRulesVars] | undefined>(
    vars ? [UGCReviewSetupApiPath.LIST_SCHEDULE_RULES, vars] : undefined
  )
}

export const useUpdateScheduleRuleApi = (options?: MutationOptions<{ ok: boolean }>) => {
  return useCallMutation<{ ok: boolean }, UpdateScheduleRuleVars>(
    UGCReviewSetupApiPath.UPDATE_SCHEDULE_RULE,
    options,
    apiPutFetcher
  )
}

export const useReviewFieldsApi = (vars: ListReviewFieldsVars | undefined) => {
  return useSWR<ListReviewFieldsResponse, Response, [string, ListReviewFieldsVars] | undefined>(
    vars ? [UGCReviewSetupApiPath.LIST_REVIEW_FIELDS, vars] : undefined
  )
}

export const useCreateReviewFieldApi = (options?: MutationOptions<{ id: number }>) => {
  return useCallMutation<{ id: number }, CreateReviewFieldVars>(
    UGCReviewSetupApiPath.CREATE_REVIEW_FIELD,
    options
  )
}

export const useDeleteReviewFieldApi = (options?: MutationOptions<{ ok: boolean }>) => {
  return useCallMutation<{ ok: boolean }, DeleteReviewFieldVars>(
    UGCReviewSetupApiPath.DELETE_REVIEW_FIELD,
    options,
    apiDeleteFetcher
  )
}

export const useCreateScheduleRuleApi = (
  options?: MutationOptions<{ id: number; priority: number }>
) => {
  return useCallMutation<{ id: number; priority: number }, CreateScheduleRuleVars>(
    UGCReviewSetupApiPath.CREATE_SCHEDULE_RULE,
    options
  )
}

export const useDeleteScheduleRuleApi = (options?: MutationOptions<{ ok: boolean }>) => {
  return useCallMutation<{ ok: boolean }, DeleteScheduleRuleVars>(
    UGCReviewSetupApiPath.DELETE_SCHEDULE_RULE,
    options,
    apiDeleteFetcher
  )
}

/** ルールの対象を選ぶための一覧（W2マスタ由来） */
export const useRuleBrandsApi = (vars: { site_id: number } | undefined) => {
  return useSWR<RuleBrandsResponse, Response, [string, { site_id: number }] | undefined>(
    vars ? [UGCReviewSetupApiPath.LIST_RULE_BRANDS, vars] : undefined
  )
}

export const useRuleCategoriesApi = (vars: { site_id: number } | undefined) => {
  return useSWR<RuleCategoriesResponse, Response, [string, { site_id: number }] | undefined>(
    vars ? [UGCReviewSetupApiPath.LIST_RULE_CATEGORIES, vars] : undefined
  )
}

export const useRulePriceRangesApi = (vars: { site_id: number } | undefined) => {
  return useSWR<RulePriceRangesResponse, Response, [string, { site_id: number }] | undefined>(
    vars ? [UGCReviewSetupApiPath.LIST_RULE_PRICE_RANGES, vars] : undefined
  )
}
